<template>
    <div class="box">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" style="text-align: center"
                 label-position="left" label-width="0px" class="demo-ruleForm login-container">
            <h3 class="title">扫吧AR 经销商密码更改</h3>
            <el-form-item prop="phone">
                <el-input type="text" v-model="ruleForm.phone" prefix-icon="el-icon-phone" auto-complete="off" clearable placeholder="请输入账号绑定手机号">
                    <el-button slot="append" @click.native.prevent="handleSendPhone">发送</el-button>
                </el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input type="password" v-model="ruleForm.password" prefix-icon="el-icon-warning" clearable auto-complete="off" placeholder="请输入新密码"></el-input>
            </el-form-item>
            <el-form-item prop="password2">
                <el-input type="password" v-model="ruleForm.password2" prefix-icon="el-icon-warning" clearable auto-complete="off" placeholder="请再次输入新密码"></el-input>
            </el-form-item>
            <el-form-item prop="code">
                <el-input type="text" v-model="ruleForm.code" prefix-icon="el-icon-warning" clearable auto-complete="off" placeholder="请输入手机收到的验证码"></el-input>
            </el-form-item>
            <el-form-item style="width:100%;">
                <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit" :loading="loading">保存</el-button>
            </el-form-item>
            <el-form-item style="width:100%;">
                <el-button type="primary" style="width:100%;" @click.native.prevent="handleReturn">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
  //import NProgress from 'nprogress'
  import store from "../vuex/store";
  import $ from "jquery";

  export default {
    data() {
      return {
        url:'/static/u30.png',
        loading: false,
        ruleForm: {
            phone: '',
            password: '',
            password2: '',
            code: ''
        },
        rules: {
            phone: [
                { required: true, message: '请输入账号绑定手机号', trigger: 'blur' },
                //{ validator: validaePass }
              ],
            password: [
                { required: true, message: '请输入密码', trigger: 'blur' },
                //{ validator: validaePass2 }
              ],
            password2: [
                { required: true, message: '请再次输入密码', trigger: 'blur' },
                //{ validator: validaePass2 }
            ],
            code: [
                { required: true, message: '请输入验证码', trigger: 'blur' },
                //{ validator: validaePass2 }
            ]
        },
        checked: true
      };
    },
    methods: {
      handleSendPhone(){
          let _this= this;
          if( _this.ruleForm.phone==""){
              _this.$message({
                  message: "请输入手机号",
                  type: "error"
              });
              return;
          }
            let params = { phone: _this.ruleForm.phone };
            let url = store.state.api+'/sms/sendcode';
            $.ajax({
                url: url,
                type: "post",
                data: params,
                cache: false,
                async: false,
                success(response) {
                  _this.$message({
                    message: "发送成功，请注意查收",
                    type: "success"
                  });
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    _this.logining = false;
                    _this.$message({
                        message: XMLHttpRequest,
                        type: "error"
                    });
                }
            })
        },
      handleReturn(){
        document.location.href = '#/login';
      },
      handleSubmit(ev) {
        var _this = this;
        _this.$refs.ruleForm.validate((valid) => {
          if (valid) {
              if(_this.ruleForm.password!=_this.ruleForm.password2){
                  _this.$message({
                      message: "两次密码不一致",
                      type: "error"
                  });
                  _this.ruleForm.password2 = "";
                  return;
              }
            _this.logining = true;
            //NProgress.start();
            let params = { phone: _this.ruleForm.phone, password: _this.ruleForm.password, code: _this.ruleForm.code };
            let url = store.state.api+'/auth/password/update';
              $.ajax({
                  url: url,
                  type: "post",
                  data: params,
                  cache: false,
                  async: false,
                  success(response) {
                    _this.$message({
                      message: "修改成功，请重新登录",
                      type: "success"
                    });
                    setTimeout(function () {
                      document.location.href = '#/login';
                    },3000)
                  },
                  error: function (XMLHttpRequest, textStatus, errorThrown) {
                      _this.logining = false;
                      _this.$message({
                          message: XMLHttpRequest,
                          type: "error"
                      });
                  }
              })
          }
        });
      }
    }
  }

</script>

<style lang="scss" scoped>

    .box {
        color: white;
        background: #2d3a4b;
    }

    .login-container {
        background-clip: padding-box;
        margin: 180px auto 20px;
        width: 450px;
        padding: 50px 90px;
        .title {
            font-size: xx-large;
            margin: 40px auto 20px auto;
            text-align: center;
            color: white;
        }
        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// Passwd.vue?00a55f3d